import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { all_routes } from "./all_routes";

/**
 * PublicRoute component that selectively redirects authenticated users
 * Only redirects from signin and forgotPassword pages, allows homepage access
 */
const PublicRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();


  const restrictedPaths = [
    all_routes.signin,
    all_routes.forgotPassword,
    // Add other paths here if needed
  ];

  // Only redirect if authenticated AND on a restricted path
  if (isAuthenticated && restrictedPaths.includes(location.pathname)) {
    return <Navigate to={all_routes.newdashboard} replace />;
  }

  // Otherwise, render the child routes (including homepage)
  return <Outlet />;
};

export default PublicRoute;
